(function () {
  'use strict';

  /* @ngdoc object
   * @name blockade
   * @description
   *
   */
  angular
    .module('blockade', []);
}());
